module.exports = __webpack_public_path__ + "img/0706-底层建筑-07.efe0cd87.png";